// removed by extract-text-webpack-plugin
module.exports = {"checktag":"_2aMbhlEQaHi3djgy_kqvSV","checkbox":"_3A78ALtmyYZKVHX_xEbySR"};


//////////////////
// WEBPACK FOOTER
// ./src/v2SPRINTA/atoms/Form/Checktag/style.module.css
// module id = 445
// module chunks = 37